import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/enrolmentModal";
import deltas from "../../actions/deltas";

const {SET_ENROLMENT_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_ENROLMENT_MODAL_STATE);
